interface QuoteTotalsSectionProps {
  subtotal: number;
  total: number;
}

const QuoteTotalsSection = ({ subtotal, total }: QuoteTotalsSectionProps) => {
  return (
    <div className="border-t pt-4">
      <div className="text-right space-y-2">
        <div className="flex justify-between">
          <span>Subtotal:</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold text-lg border-t pt-2">
          <span>Total Amount:</span>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default QuoteTotalsSection;